import { render, staticRenderFns } from "./WhatsAppCheckout.vue?vue&type=template&id=5906968b"
import script from "./WhatsAppCheckout.vue?vue&type=script&lang=js"
export * from "./WhatsAppCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports